module.exports = __webpack_public_path__ + "static/img/home_logo.9b82587.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_logo.gif
// module id = uFPf
// module chunks = 3